export default "__VITE_ASSET__6e4582b6__"